import React from "react";
import GeoFencePage from "../GeoFencePage";

import {
    PageHeader,
    Panel,
} from "../../components/ui/AdminUI";

export default function GeoFenceEmployeePage() {
    return (
        <div className="space-y-6">

            <PageHeader
                title="GeoFence Monitoring"
                subtitle="Monitor delivery zones, boundary violations and shipment location."
            />

            <Panel>
                <GeoFencePage />
            </Panel>

        </div>
    );
}